import apiClient from "./axios"

const BASE_URL = "/gemini-image/extract-auction-sheet"

export const extractAuctionSheet = async (file, skipToast = false) => {
  const formData = new FormData()
  formData.append("image", file)
  const response = await apiClient.post(BASE_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    skipToast,
  })
  return response.data
}

export const onboardAuctionSheet = async vehicleInfo => {
  const { data } = await apiClient.post("/vehicle-stocks/auction-sheet-onboard", {
    vehicle_info: vehicleInfo,
  })
  return data
}